import { queryClient } from '@/client/utils/query-client';
import type { QueryKey } from '@tanstack/react-query';

export const matchesQueryType = (key: QueryKey, type: string): boolean => key[0] === type || key[1] === type;

// Active (mounted, enabled) entries of the type refetch now. Inactive cached entries are only
// marked stale: they refetch on their next mount, not at once.
export const refetchQuery = async (fastKey: string) => {
  return await queryClient.invalidateQueries({ predicate: query => matchesQueryType(query.queryKey, fastKey) });
};

export const resetQuery = (fastKey: string) => {
  return queryClient.resetQueries({ predicate: query => matchesQueryType(query.queryKey, fastKey) });
};

export const refetchUserLogin = async () => await refetchQuery('UserLogin');
export const resetUserLogin = () => resetQuery('UserLogin');

export const refetchSignedUserAssets = async () => await refetchQuery('SignedUserAssets');
export const resetQuerySignedUserAssets = () => resetQuery('SignedUserAssets');

export const refetchSignedUserInfo = async () => await refetchQuery('SignedUserInfo');
export const resetQuerySignedUserInfo = () => resetQuery('SignedUserInfo');

export const getMarketTags = () => queryClient.getQueryData(['MarketTags', 1, 20]) as string[];

export const refetchUserPositions = async () => await refetchQuery('UserPositions');

export const refetchMarketPosts = async () => await refetchQuery('MarketPosts');
export const refetchComments = async () => await refetchQuery('Comments');

export const refetchSignedNotifications = async () => await refetchQuery('SignedNotifications');
